<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Promo Code</h2>
    <div class="row">
        <mat-progress-bar *ngIf="isLoading" [color]="'primary'" [mode]="'indeterminate'"></mat-progress-bar>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="w-100">
                        <mat-label>Code</mat-label>
                        <input matInput formControlName="code" required>
                        <mat-error *ngIf="form.get('code').errors?.required">Code is required</mat-error>
                        <mat-error *ngIf="form.get('code').errors?.validationErrors">
                            {{ form.get("code").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Discount Type</mat-label>
                        <mat-select formControlName="discountType" required>
                            <mat-option [value]="DiscountType.Percentage">Percentage</mat-option>
                            <mat-option [value]="DiscountType.FixedAmount">Fixed Amount</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Discount Amount</mat-label>
                        <input matInput type="number" formControlName="discountAmount" required>
                        <mat-error *ngIf="form.get('discountAmount').errors?.required">Discount Amount is
                            required</mat-error>
                        <span matSuffix>{{form.get('discountType').value === DiscountType.Percentage ? '%' :
                            '$'}}</span>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <mat-form-field class="w-100">
                        <mat-label>Start Date</mat-label>
                        <mat-date-range-input [rangePicker]="rangePicker">
                            <input matStartDate formControlName="startDate" placeholder="Start date">
                            <input matEndDate formControlName="endDate" placeholder="End date">
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #rangePicker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Start time</mat-label>
                        <input matInput [matTimepicker]="startTimePicker" formControlName="startTimeOnly">
                        <mat-timepicker-toggle matIconSuffix [for]="startTimePicker" />
                        <mat-timepicker #startTimePicker />
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>End time</mat-label>
                        <input matInput [matTimepicker]="endTimePicker" formControlName="endTimeOnly">
                        <mat-timepicker-toggle matIconSuffix [for]="endTimePicker" />
                        <mat-timepicker #endTimePicker />
                    </mat-form-field>
                </div>

                <div class="row">
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Usage Limit</mat-label>
                            <input matInput type="number" formControlName="usageLimit">
                            <mat-hint>Leave empty for unlimited use</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-6 d-flex align-items-center">
                        <mat-slide-toggle formControlName="isActive">
                            Active
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-raised-button type="submit" [disabled]="!form.valid || isLoading">
                Create
            </button>
            <button mat-button type="button" [mat-dialog-close]="false" class="warning">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>